// Formatea un número entero o decimal a un String con el valor en formato moneda
export const formatNumber = (number) => {
  const formatter = new Intl.NumberFormat();
  return formatter.format(number);
};

// Si el valor de la cobertura es un número, lo mejor es formatearla a money format
export const formatCoverageValue = (coverageValue) => {
  if (coverageValue === true || coverageValue === null || coverageValue === undefined) return null;
  if (typeof coverageValue === 'string' && !coverageValue.trim()) return null;

  const asNumber = Number(coverageValue);

  // Si es un Número, se debe formatear a moneda
  if (!Number.isNaN(asNumber)) {
    if (asNumber === 0) return null;  // Si es 0, no se muestra nada
    return `$${formatNumber(coverageValue)}`;
  }

  return coverageValue;
};

export const makeid = (length) => {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
